import { HTMLAttributes } from 'react'
import clsx from 'clsx'
import styles from './ContentContainer.module.css'

export interface ContentContainerProps extends HTMLAttributes<HTMLDivElement> {
	isDeleted?: boolean
}

export default function ContentContainer({
	isDeleted = false,
	className,
	...props
}: ContentContainerProps) {
	return <div className={clsx(styles.root, isDeleted && styles.deleted, className)} {...props} />
}
